import Regex from './Regex'

export default class MobilePhoneNumber extends Regex {
  get ruleName () {
    return 'mobilePhoneNumber'
  }

  passes () {
    // TODO you should be able to specify country codes in parameter : e.g. 33 ...
    /*
     * DOM TOM
     * 590
     596
     594
     262
     269
     * */
    return super.passes(/^(?:(?:(?:\+|00)(?:33|352|39|34|49|41|377|31|590|596|594|262|269))|0)[^12345]\d{6,12}$/)
    // return super.passes(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/)
  }
}
